import { breakpointsMinSize } from '../_hooks/useCurrentMedia'

/** Story.paramaters.chromatic.viewports */
export const viewports = Object.values({
  ...breakpointsMinSize,
  mobile: 360,
})
  .map((val) => {
    return [val - 1, val + 1]
  })
  .flat()
